const scheduleJson = {
  status: "success",
  schedules: [
    {
      id: "sch_68b599660658e6.90880464",
      name: "female_normal",
      schedule: {
        "00:00T01:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "02:00T03:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "08:00T09:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "10:00T11:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "14:00T15:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "16:00T17:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:02:30+00:00",
      updated_at: "2025-09-01T13:09:38+00:00",
    },
    {
      id: "sch_68b59a13bd23c0.22489593",
      name: "female_intense",
      schedule: {
        "00:00T01:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "02:00T03:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "08:00T09:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "10:00T11:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "12:00T13:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "14:00T15:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "16:00T17:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "17:45T18:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:05:23+00:00",
    },
    {
      id: "sch_68b59a425d73c5.73373781",
      name: "male_normal_a",
      schedule: {
        "01:00T02:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "03:00T04:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "05:00T06:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "07:00T08:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "09:00T10:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "11:00T12:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "13:00T14:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "15:00T16:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "17:00T18:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "19:00T20:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "21:00T22:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "23:00T00:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:06:10+00:00",
    },
    {
      id: "sch_68b59a5fd01666.34244033",
      name: "male_normal_b",
      schedule: {
        "01:15T02:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "03:15T04:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "05:15T06:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "07:15T08:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "09:15T10:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "11:15T12:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "13:15T14:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "15:15T16:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "17:15T18:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "19:15T20:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "21:15T22:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "23:15T00:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:06:39+00:00",
    },
    {
      id: "sch_68b59abbbdc6b0.37734648",
      name: "male_intense_a",
      schedule: {
        "00:30T01:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "02:00T03:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "03:30T04:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "05:00T06:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "06:30T07:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "08:00T09:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "09:30T10:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "11:00T12:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "12:30T13:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "14:00T15:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "15:30T16:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "17:00T18:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "18:30T19:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "20:00T21:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "21:30T22:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "23:00T00:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:08:11+00:00",
    },
    {
      id: "sch_68b59aeabfb797.15331966",
      name: "male_intense_b",
      schedule: {
        "00:45T01:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "02:15T03:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "03:45T04:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "05:15T06:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "06:45T07:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "08:15T09:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "09:45T10:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "11:15T12:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "12:45T13:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "14:15T15:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "15:45T16:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "17:15T18:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "18:45T19:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "20:15T21:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "21:45T22:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "23:15T00:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:08:58+00:00",
    },
    {
      id: "sch_68b59af8d65fc7.51598590",
      name: "male_intense_c",
      schedule: {
        "01:00T02:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "02:30T03:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "04:00T05:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "05:30T06:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "07:00T08:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "08:30T09:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "10:00T11:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "11:30T12:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "13:00T14:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "14:30T15:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "16:00T17:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "17:30T18:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "19:00T20:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "20:30T21:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "22:00T23:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "23:30T00:30": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:09:12+00:00",
    },
    {
      id: "sch_68b59b087119c3.80649334",
      name: "male_intense_d",
      schedule: {
        "01:15T02:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "02:45T03:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "04:15T05:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "05:45T06:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "07:15T08:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "08:45T09:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "10:15T11:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "11:45T12:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "13:15T14:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "14:45T15:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "16:15T17:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "17:45T18:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "19:15T20:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "20:45T21:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "22:15T23:15": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
        "23:45T00:45": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
      },
      created_at: "2025-09-01T13:09:28+00:00",
    },
  ],
};
export default scheduleJson;